import {http} from '~/services/http';

import {LOGOUT, LOGIN_FAIL, LOAD_USER} from './types';
import tokenStorage from "~/services/tokenStorage";
import {AUTH_TOKEN} from "~/services/http/axios";
import {loadTranslationsAction, setCurrentLanguage} from "~/redux/actions/translations";

export const loadUserAction = () => async (dispatch) => {
    const userResponse = await http.get('/auth/me');

    const user = userResponse.data || null;

    dispatch({
        type: LOAD_USER,
        payload: user
    });

    const savedLangId = localStorage.getItem('preferred-language-id');
    if (user && user.language && !savedLangId) {
        dispatch(setCurrentLanguage(user.language));
    }
};

export const updateUserAction = (form) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    try {

        const userResponse = await http.post('/auth/update', form, requestOptions);

        dispatch({
            type: LOAD_USER,
            payload: userResponse.data || null
        });

    } catch (error) {
        console.log('error', error);
        throw error.response;
    }
};

export const loginAction = (code) => async (dispatch, getState) => {

    const { currentLanguage } = getState()?.translations;

    const requestOptions = {
        headers: {
            "Content-Language": currentLanguage.code
        }
    }

    const body = {
        code: code,
    };

    try {
        const res = await http.post('/auth/login', body, requestOptions);
        let token = res.data?.token;
        tokenStorage.setItem(AUTH_TOKEN, token);
        dispatch(loadTranslationsAction());
        dispatch(loadUserAction());
        return res;

    } catch (error) {
        dispatch({
            type: LOGIN_FAIL,
        });
        return error.response;
    }
};

export const logoutAction = () => (dispatch) => {
    tokenStorage.removeItem(AUTH_TOKEN);
    dispatch({type: LOGOUT});
};
